import React, { useState } from "react";
import {
  OMNISCAN_CORPORATE_RED,
  OMNISCAN_CORPORATE_GREEN,
  OMNISCAN_CORPORATE_PINK
} from "../../../constants/colors";

export default function AssetChartOutages() {

    const OMNI = {
        GREEN: OMNISCAN_CORPORATE_GREEN,
        RED: OMNISCAN_CORPORATE_RED,
        PINK: OMNISCAN_CORPORATE_PINK
    };

    const chartContainer = {
        height: "150px",
        borderRadius: "14px",
        background: "linear-gradient(180deg, #0e0f12 0%, #0a0b0e 100%)",
        border: "1px solid rgba(255,255,255,0.06)",
        overflow: "hidden"
    };

    function adjustColor(hex, amount) {
        var c = hex.replace("#", "");
        var r = parseInt(c.substring(0, 2), 16);
        var g = parseInt(c.substring(2, 4), 16);
        var b = parseInt(c.substring(4, 6), 16);

        r = Math.min(255, Math.max(0, r + amount));
        g = Math.min(255, Math.max(0, g + amount));
        b = Math.min(255, Math.max(0, b + amount));

        return (
            "#" +
            r.toString(16).padStart(2, "0") +
            g.toString(16).padStart(2, "0") +
            b.toString(16).padStart(2, "0")
        );
    }

    function generateOutageData(days) {
        var data = [];
        for (var i = 0; i < days; i++) {
            var minutes = 2 + Math.random() * 6;
            var r = Math.random();

            if (r > 0.92) {
                minutes += 180 + Math.random() * 240;
            } else if (r > 0.80) {
                minutes += 30 + Math.random() * 90;
            }

            data.push(Math.round(minutes));
        }
        return data;
    }

    const outageData = React.useMemo(function () {
        return generateOutageData(365);
    }, []);

    const [hoverIndex, setHoverIndex] = useState(null);

    function getBarFill(v) {
        if (v > 180) return adjustColor(OMNI.RED, 25);
        if (v > 30) return adjustColor(OMNI.PINK, 20);
        return adjustColor(OMNI.GREEN, 20);
    }

    function OutageBarChart({ data, height }) {

        var max = Math.max.apply(null, data);
        var BAR_STEP = 2;
        var chartWidth = data.length * BAR_STEP;

        function barHeight(v) {
            if (max === 0) return 2;
            return Math.max(2, (v / max) * (height - 8));
        }

        return (
            <svg
                width="100%"
                height={height}
                viewBox={"0 0 " + chartWidth + " " + height}
                preserveAspectRatio="none"
                onMouseLeave={function () { setHoverIndex(null); }}
            >
                {/* HORIZONTAL SEVERITY BANDS 
                <rect
                    x="0"
                    y={height * 0.66}
                    width={chartWidth}
                    height={height * 0.34}
                    fill="rgba(255,255,255,0.13)"
                />

                <rect
                    x="0"
                    y={height * 0.33}
                    width={chartWidth}
                    height={height * 0.33}
                    fill="rgba(255,255,255,0.15)"
                />

                <rect
                    x="0"
                    y="0"
                    width={chartWidth}
                    height={height * 0.33}
                    fill="rgba(255,255,255,0.17)"
                />
				*/}
                {/* BASELINE */}
                <line
                    x1="0"
                    x2={chartWidth}
                    y1={height - 2}
                    y2={height - 2}
                    stroke="rgba(255,255,255,0.18)"
                    strokeWidth="1"
                />

                {/* BARS */}
                {data.map(function (v, i) {

                    var h = barHeight(v);
                    var fill = getBarFill(v);
                    var isHover = hoverIndex === i;

                    return (
                        <rect
                            key={i}
                            x={i * BAR_STEP}
                            y={height - h}
                            width={1.6}
                            height={h}
                            rx={1}
                            fill={isHover ? adjustColor(fill, 35) : fill}
                            opacity={isHover ? 1 : 0.9}
                            style={{
                                filter: "drop-shadow(0 0 2px rgba(255,255,255,0.15))"
                            }}
                            onMouseEnter={function () { setHoverIndex(i); }}
                        />
                    );
                })}
            </svg>
        );
    }

    return (
        <div style={chartContainer}>
            <OutageBarChart data={outageData} height={150} />
        </div>
    );
}